import { jsx as _jsx } from "react/jsx-runtime";
import { GetProductData } from '@themes/common/data';
import { createRoot } from 'react-dom/client';
import jQuery from 'jquery';
import ExtraProductItem from './ExtraProductItem';
import AppProvider from '@components/Shared/State/provider';
import useProductPage from '@themes/product/useProductPage';
import { useEffect, useMemo } from 'react';
import { ArrayContains } from '@themes/common/utils';
const SwiperExtraProducts = ({ items, quantity }) => {
    return (_jsx("div", Object.assign({ className: 'sb-recommendation--container' }, { children: _jsx("div", Object.assign({ className: 'ais-page' }, { children: _jsx("div", Object.assign({ className: 'ais-results-as-block' }, { children: _jsx("div", Object.assign({ className: 'algolia-recommendation--row' }, { children: _jsx("swiper-container", Object.assign({ class: 'sb-swiper', "slides-per-view": 'auto', navigation: true, loop: true, style: {
                            marginLeft: 'unset',
                        } }, { children: items.map((item) => (_jsx("swiper-slide", { children: _jsx(ExtraProductItem, Object.assign({}, item, { main_product_quantity: quantity, section: 'product' }), item.variant_id) }, item.variant_id))) })) })) })) })) })));
};
const ExtraProducts = ({ variant_id, items, element }) => {
    const [{ variantId, quantity, extraProducts: extraProductsState }] = useProductPage(variant_id, 1, items, items[0], false, false);
    const extraProducts = useMemo(() => (extraProductsState !== null && extraProductsState !== void 0 ? extraProductsState : []).filter((item) => { var _a; return ((_a = item.variant_id) === null || _a === void 0 ? void 0 : _a.toString()) !== (variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString()) && !ArrayContains(item.tags, 'Poolsten:Hörn'); }), [extraProductsState, variant_id]);
    useEffect(() => {
        const parent = jQuery(element).closest('.extra-products--container');
        if (!extraProducts.length) {
            parent.hide();
        }
        else {
            parent.show();
        }
    }, [element, extraProducts, variantId]);
    return _jsx(SwiperExtraProducts, { items: extraProducts, quantity: quantity, element: element }, variantId);
};
const LoadExtraProducts = (id, items) => {
    const renderElements = jQuery(`.extra-products--wrapper[data-product-id="${id}"]`);
    if (!renderElements.length) {
        return;
    }
    for (const element of renderElements) {
        const root = createRoot(element);
        const product = GetProductData(id);
        root.render(_jsx(AppProvider, { children: _jsx(ExtraProducts, { product: product, items: items, variant_id: id, element: element }) }));
    }
};
export default LoadExtraProducts;
